const state = {
  payments: [],
  all_payments: [],
  payments_error: false,
  all_payments_error: false,

  payments_pagination: {
    on_page: 20,
    page_number: 1,
  },
  all_payments_pagination: {
    on_page: 0,
    page_number: 0,
    total: 0,
  },
  user_payments: [],
  user_payments_error: false,
  payouts: [],
  payouts_error: false,
  numberOfWaitingWithdraws: 0

};

const mutations = {
  SET_ALL_PAYMENTS(state, payload) {
    state.all_payments = payload;
  },
  SET_ALL_PAYMENTS_PAGINATION(state, payload) {
    state.all_payments_pagination = payload;
  },
  SET_ALL_PAYMENTS_ERROR(state, payload) {
    state.all_payments_error = payload;
  },
  SET_PAYMENTS(state, payload) {
    state.payments = payload;
  },
  SET_PAYMENTS_ERROR(state, error) {
    state.payments_error = error;
  },
  SET_PAYMENTS_PAGINATION(state, res) {
    state.payments_pagination = {
      on_page: res.on_page,
      page_number: res.page_number,
    };
  },
  SET_USER_PAYMENTS(state, payload) {
    state.user_payments = payload;
  },
  SET_USER_PAYMENTS_ERROR(state, error) {
    state.user_payments_error = error;
  },
  SET_ALL_PAYOUTS(state, payload) {
    state.payouts = payload
  },
  SET_ALL_PAYOUTS_ERROR(state, error) {
    state.payouts_error = error;
  },
  SET_PAYMENTS_TO_NULL(state) {
    state.payments = null
  },
  CLEAR_ALL_PAYMENTS(state) {
    state.all_payments = [];
    state.all_payments_pagination = {
      on_page: 0,
      page_number: 0,
      total: 0,
    };
    state.all_payments_error = false;
  },
  SET_NUMBER_OF_WAITING_MESSAGES(state, number) {
    state.numberOfWaitingWithdraws = number
  }
};

const getters = {
  getPayments: (state) => {
    return {
      data: state.payments,
      error: state.payments_error,
      pagination: state.payments_pagination,
    };
  },
  getUserPayments: (state) => {
    return { data: state.user_payments, error: state.user_payments_error };
  },
  getAllPayments: (state) => {
    return {
      data: state.all_payments,
      error: state.all_payments_error,
      pagination: state.all_payments_pagination,
    }
  },
  getAllPayouts: (state) => {
    return state.payouts;
  },
  getNumberOfWaitingWithdraws: state => {
    return state.numberOfWaitingWithdraws;
  }
};

export default {
  state,
  mutations,
  getters,
};
